<template>
  <v-card elevation="0" :loading="saving" :disabled="saving">
    <v-card-title class="bg-primary text-white d-flex justify-space-between align-center">
      <span>{{ timeLabel }}</span>
      <v-btn
        icon
        title="Fermer"
        variant="text"
        size="small"
        @click="close"
      >
        <v-icon size="large">
          mdi-close
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text ref="mealCardContent" class="mealEditionCard pb-3">
      <v-row dense justify="space-between">
        <v-col cols="auto">
          <v-card
            width="100"
            elevation="0"
            class="d-flex flex-column align-center cursor-pointer bg-transparent"
            :disabled="lastMeals.length === 0"
            @click="localMeal.ignored_type === 'leftover' ? localMeal.ignored_type = '' : localMeal.ignored_type = 'leftover'"
          >
            <v-card
              height="100"
              width="100"
              elevation="1"
              rounded="lg"
              :class="['position-relative overflow-hidden ignoredImageCard', localMeal.ignored_type === 'leftover' ? 'selected' : '']"
            >
              <v-img
                :src="leftoverImg"
                height="100px"
                width="100px"
                cover
              />
              <div v-if="localMeal.ignored_type === 'leftover'" class="selected-overlay-badge">
                <v-icon size="large" color="primary">
                  mdi-check-outline
                </v-icon>
              </div>
            </v-card>
            <div class="ignoredCardLabel text-subtitle-2 text-primary font-weight-medium mt-1 text-center">
              Restes
            </div>
          </v-card>
        </v-col>

        <v-col v-if="localMeal.ignored_type !== 'leftover'" cols="auto">
          <v-card
            width="100"
            elevation="0"
            class="d-flex flex-column align-center cursor-pointer bg-transparent"
            @click="localMeal.ignored_type === 'restaurant' ? localMeal.ignored_type = '' : localMeal.ignored_type = 'restaurant'"
          >
            <v-card
              height="100"
              width="100"
              elevation="1"
              rounded="lg"
              :class="['position-relative overflow-hidden ignoredImageCard', localMeal.ignored_type === 'restaurant' ? 'selected' : '']"
            >
              <v-img
                :src="restaurantImg"
                height="100px"
                width="100px"
                cover
              />
              <div v-if="localMeal.ignored_type === 'restaurant'" class="selected-overlay-badge">
                <v-icon size="large" color="primary">
                  mdi-check-outline
                </v-icon>
              </div>
            </v-card>
            <div class="ignoredCardLabel text-subtitle-2 text-primary font-weight-medium mt-1 text-center">
              Restaurant
            </div>
          </v-card>
        </v-col>

        <v-col v-if="localMeal.ignored_type !== 'leftover'" cols="auto">
          <v-card
            width="100"
            elevation="0"
            class="d-flex flex-column align-center cursor-pointer bg-transparent"
            @click="localMeal.ignored_type === 'other' ? localMeal.ignored_type = '' : localMeal.ignored_type = 'other'"
          >
            <v-card
              height="100"
              width="100"
              elevation="1"
              rounded="lg"
              :class="['position-relative overflow-hidden ignoredImageCard', localMeal.ignored_type === 'other' ? 'selected' : '']"
            >
              <v-img
                :src="otherImg"
                height="100px"
                width="100px"
                cover
              />
              <div v-if="localMeal.ignored_type === 'other'" class="selected-overlay-badge">
                <v-icon size="large" color="primary">
                  mdi-check-outline
                </v-icon>
              </div>
            </v-card>
            <div class="ignoredCardLabel text-subtitle-2 text-primary font-weight-medium mt-1 text-center">
              Autre
            </div>
          </v-card>
        </v-col>
        <v-col v-if="localMeal.ignored_type === 'leftover'" cols="8" md="8">
          On mange les restes de :
          <v-list
            class="lastMeals scrollbars"
            density="compact"
          >
            <v-list-item
              v-for="item in lastMeals"
              :key="item.id"
            >
              <v-list-item-title
                class="upperFirstLetter ellipsedTitle"
                :title="formatMeal(item.id)"
              >
                {{ formatMeal(item.id) }}
              </v-list-item-title>

              <template #append>
                <v-btn
                  v-if="!isIgnoredLeftover(item.id)"
                  icon
                  color="primary"
                  variant="flat"
                  size="small"
                  density="compact"
                  @click="addIgnoredLeftover(item.id)"
                >
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
                <v-btn
                  v-if="isIgnoredLeftover(item.id)"
                  icon
                  color="primary"
                  variant="outlined"
                  size="small"
                  density="compact"
                  @click="removeIgnoredLeftover(item.id)"
                >
                  <v-icon>
                    mdi-minus
                  </v-icon>
                </v-btn>
              </template>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>

      <v-row v-if="!localMeal.ignored" align="center" class="mt-4">
        <v-col cols="auto" class="flex-grow-1 py-0">
          <v-divider />
        </v-col>
        <v-col cols="auto" class="py-0">
          OU
        </v-col>
        <v-col cols="auto" class="flex-grow-1 py-0">
          <v-divider />
        </v-col>
      </v-row>

      <v-row v-if="!localMeal.ignored">
        <v-col cols="12" :md="extensionOpened ? 6 : 12" class="pa-2">
          <v-row v-if="!localMeal.ignored" class="my-0" align="center">
            <v-col class="pb-0">
              <v-textarea
                ref="name"
                v-model="localMeal.name"
                label="Plat"
                hide-details
                auto-grow
                rows="1"
                variant="outlined"
                class="name"
              />
            </v-col>
          </v-row>
          <v-row v-if="!localMeal.ignored" dense align="center">
            <v-col class="text-center">
              <v-btn
                color="primary"
                size="x-small"
                :variant="showRecipeSearch ? 'flat' : 'outlined'"
                title="Chercher dans les recettes"
                class="ml-2"
                @click="toggleRecipeSearch"
              >
                <v-icon class="mr-2">
                  mdi-pasta
                </v-icon>
                Des recettes
              </v-btn>
            </v-col>
            <v-col class="text-center">
              <v-btn
                color="primary"
                size="x-small"
                :variant="showIdeas ? 'flat' : 'outlined'"
                title="On a fait quoi avant ?"
                class="ml-2"
                @click="toggleIdeas"
              >
                <v-icon class="mr-2">
                  mdi-lightbulb-on
                </v-icon>
                Des idées
              </v-btn>
            </v-col>
            <v-col class="text-center">
              <v-btn
                color="primary"
                size="x-small"
                :variant="showSeason ? 'flat' : 'outlined'"
                title="On a fait quoi avant ?"
                class="ml-2"
                @click="toggleSeason"
              >
                <v-icon class="mr-2">
                  mdi-sprout
                </v-icon>
                De saison
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-if="localMeal.recipes && localMeal.recipes.length > 0"
            dense
            class="mt-4"
          >
            <v-col cols="auto" align-self="start">
              Recettes :
            </v-col>
            <v-col grow>
              <v-chip
                v-for="recipe in localMeal.recipes"
                :key="recipe.recipe_id"
                closable
                color="secondary"
                class="mr-2 mb-2"
                variant="elevated"
                size="small"
                @click:close="removeRecipe(recipe.recipe_id)"
              >
                {{ recipe.recipe ? recipe.recipe.name : '...' }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="!localMeal.ignored" cols="auto">
              Nombre de personnes :
              <int-stepper v-model="localMeal.nb_people" :min="1" />
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showRecipeSearch" cols="12" md="6" class="pa-2">
          <v-divider v-if="$vuetify.display.xs" />
          <v-row class="my-0">
            <v-col>
              <v-text-field
                v-if="searchby==='recipe'"
                ref="searchRecipeInput"
                v-model="searchRecipe"
                variant="outlined"
                density="compact"
                hide-details
                clearable
                label="Recherche"
                placeholder="Cherchez une recette..."
                :loading="searchLoading"
                @update:model-value="triggerSearchRecipe"
              />
              <v-autocomplete
                v-if="searchby=='ingredient'"
                ref="searchIngredientInput"
                v-model="selectedRecipeIngredient"
                v-model:search="searchRecipeIngredient"
                :loading="searchLoading"
                :items="searchIngredientsResults"
                item-value="id"
                item-title="name"
                density="compact"
                hide-details
                label="Cherchez un ingrédient..."
                variant="outlined"
                single-line
                clearable
                return-object
                no-data-text="Aucun ingrédient trouvé"
                no-filter
                :readonly="!!selectedRecipeIngredient"
                @update:model-value="triggerSearchRecipeByIngredient"
              />
            </v-col>
            <v-col cols="auto">
              <VDropdown
                :container="$refs.mealCardContent.$el"
              >
                <v-btn
                  icon
                  variant="outlined"
                  size="small"
                  color="primary"
                  :loading="searchLoading"
                >
                  <v-icon>
                    mdi-filter-variant
                  </v-icon>
                </v-btn>
                <template #popper>
                  <v-container>
                    <v-btn variant="text" @click="searchby='recipe'">
                      <v-icon class="mr-1">
                        {{ searchby === 'recipe' ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline' }}
                      </v-icon>
                      Par recette
                    </v-btn>
                    <v-btn variant="text" @click="searchby='ingredient'">
                      <v-icon class="mr-1">
                        {{ searchby === 'ingredient' ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline' }}
                      </v-icon>
                      Par ingredient
                    </v-btn>
                    <div>
                      <v-select
                        v-if="searchby === 'recipe'"
                        v-model="searchDishType"
                        :menu-props="{ attach: true }"
                        :items="dishTypes"
                        item-title="text"
                        item-value="value"
                        label="Type de plat"
                        clearable
                        variant="outlined"
                        multiple
                        hide-details
                        density="compact"
                        class="mt-2"
                      />
                    </div>
                  </v-container>
                </template>
              </VDropdown>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col v-if="searchRecipeResults.length > 0" class="searchResults scrollbars">
              <recipe-card
                v-for="recipe in searchRecipeResults"
                :key="recipe.id"
                :recipe-id="parseInt(recipe.id)"
                class="mb-2"
                @clicked-card="addRecipe(recipe)"
              />
            </v-col>
            <v-col v-if="searchRecipeByIngredientsResults.length > 0" class="searchResults scrollbars">
              <recipe-card
                v-for="recipe in searchRecipeByIngredientsResults"
                :key="recipe.id"
                :recipe-id="parseInt(recipe.id)"
                class="mb-2"
                @clicked-card="addRecipe(recipe)"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showIdeas" cols="12" md="6">
          <v-divider v-if="$vuetify.display.xs" />
          <v-tabs
            v-model="ideasTab"
            color="primary"
          >
            <v-tab value="ideas">
              Dans le passé
            </v-tab>
            <v-tab value="batch">
              Batch cooking
            </v-tab>
          </v-tabs>

          <v-window v-model="ideasTab">
            <v-window-item value="ideas">
              <template v-if="ideasLoading">
                <p class="text-center text-h5 loadingText">
                  Chargement
                </p>
              </template>
              <template v-else>
                <template v-if="ideas && ideas.length > 0">
                  <p class="sticky text-h5 text--primary my-3">
                    Le {{ mealDay }} c'est :
                  </p>
                  <div class="extensionContainer scrollbars">
                    <div v-for="idea in ideas" :key="idea.id" class="d-flex align-start justify-start pb-2">
                      <v-btn
                        variant="outlined"
                        size="x-small"
                        class="mr-2"
                        :loading="reuseMealLoader === idea.id"
                        @click="reuseMeal(idea.id, idea.name)"
                      >
                        On fait ça !
                      </v-btn>
                      <span>
                        {{ idea.name }}
                      </span>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <p>
                    Rien à reprendre des semaines précédentes...
                  </p>
                </template>
              </template>
            </v-window-item>
            <v-window-item value="batch">
              <template v-if="batchIngs && batchIngs.length > 0">
                <p class="sticky text-h5 text--primary my-3">
                  Déjà utilisé cette semaine :
                </p>
                <div class="extensionContainer scrollbars">
                  <div v-for="section in batchIngs" :key="section.value">
                    <p v-if="section.ingredients && section.ingredients.length > 0" class="text-h6 text-primary">
                      {{ section.text }}
                    </p>
                    <div v-for="ingredient in section.ingredients" :key="ingredient.id" class="d-flex align-start pb-2">
                      <span :class="!ingredient.image_url ? 'd-flex align-center' : 'd-flex align-center'">
                        <v-btn
                          variant="outlined"
                          :class="!ingredient.image_url ? 'mr-12' : 'mr-4'"
                          prepend-icon="mdi-magnify"
                          size="x-small"
                          @click="toggleRecipeSearch({filter: 'ingredient', filterValue: ingredient.id})"
                        >
                          Recettes
                        </v-btn>
                        <v-img
                          v-if="ingredient.image_url"
                          :src="ingredient.image_url"
                          height="24"
                          width="24"
                          class="ma-0 mr-2"
                        />
                        {{ ingredient.name }}
                        <VDropdown
                          class="inlineTooltip ml-2"
                          auto-hide
                        >
                          <v-chip
                            pill
                            title="Repas"
                            size="small"
                          >
                            <v-avatar start color="primary">
                              <v-icon>
                                mdi-silverware-fork-knife
                              </v-icon>
                            </v-avatar>
                            {{ ingredient.composition.length }}
                          </v-chip>
                          <template #popper>
                            <div class="pa-2">
                              <div v-for="compo in ingredient.composition" :key="compo.id" class="upperFirstLetter">
                                {{ compo.meal.name }} ({{ compo.meal.shortDate + getMealBakingTypes(compo.meal) }})
                              </div>
                            </div>
                          </template>
                        </VDropdown>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <p>
                  Aucun ingrédient utilisé cette semaine...
                </p>
              </template>
            </v-window-item>
          </v-window>
        </v-col>
        <v-col v-if="showSeason" cols="12" md="6">
          <v-row dense>
            <v-col>
              <template v-if="ideasLoading">
                <p class="text-center text-h5 loadingText">
                  Chargement
                </p>
              </template>
              <template v-else>
                <p class="sticky text-h5 text--primary my-3">
                  C'est de saison :
                </p>
                <div class="extensionContainer scrollbars">
                  <v-expansion-panels variant="accordion">
                    <v-expansion-panel
                      v-for="(ingList, ingType) in seasonables"
                      :key="ingType"
                      :title="formatIngType(ingType)+' ('+ingList.length+')'"
                      elevation="0"
                      bg-color="background"
                    >
                      <v-expansion-panel-text
                        class="ligthenBg"
                      >
                        <div v-for="ing in ingList" :key="ing.id" class="d-flex align-center justify-start pb-2 pl-2 mx-n6">
                          <v-btn
                            size="x-small"
                            variant="outlined"
                            class="mr-2"
                            :prepend-icon="$vuetify.display.xs ? '' : 'mdi-plus'"
                            :loading="reuseMealLoader === ing.id"
                            @click="addIngredient(ing.name)"
                          >
                            Ajouter
                          </v-btn>
                          <v-btn
                            variant="outlined"
                            class="mr-2"
                            :prepend-icon="$vuetify.display.xs ? '' : 'mdi-magnify'"
                            size="x-small"
                            @click="toggleRecipeSearch({filter: 'ingredient', filterValue: ing.id})"
                          >
                            Recettes
                          </v-btn>
                          <v-img
                            v-if="ing.image_url"
                            :src="ing.image_url"
                            height="24"
                            width="24"
                            class="ma-0 mr-2 flex-grow-0"
                          />
                          <span v-else class="placeholderIngImage mr-2" />
                          <span>
                            {{ ing.name }}
                          </span>
                        </div>
                      </v-expansion-panel-text>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </template>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="my-4" />
      <v-row
        class="mb-0"
        dense
      >
        <v-col>
          <v-btn variant="text" size="small" title="Ajouter un commentaire" class="pa-0" @click="toggleComment">
            <v-icon v-if="!(localMeal.comment || displayComment)" class="mr-2">
              mdi-checkbox-blank-outline
            </v-icon>
            <v-icon v-if="localMeal.comment || displayComment" class="mr-2">
              mdi-checkbox-marked-outline
            </v-icon>
            Ajouter un commentaire
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="localMeal.comment || displayComment" dense class="my-0">
        <v-col cols="12">
          <v-textarea
            ref="comment"
            v-model="localMeal.comment"
            variant="outlined"
            rows="2"
            hide-details
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn variant="text" @click="close">
        Annuler
      </v-btn>
      <v-btn color="primary" variant="flat" @click="saveMeal">
        {{ !meal || !localMeal.id ? 'Créer' : 'Enregistrer' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from "lodash"
import moment from "moment"
import { useRepo } from "pinia-orm"
import { Meal, MealRepo } from "@/models/Meal"
import { Ingredient, IngredientRepo } from "@/models/Ingredient"
import { Recipe, RecipeRepo } from "@/models/Recipe"
import RecipeCard from "@/components/RecipeCard"
import IntStepper from '@/components/IntStepper.vue'
import { useToast } from 'vue-toastification'
import restaurantImg from '@/assets/new_restaurant_sq.jpg'
import leftoverImg from '@/assets/new_leftover_sq.jpg'
import otherImg from '@/assets/new_other_sq.jpg'

export default {
  name: "MealCard",
  components: {
    RecipeCard,
    IntStepper
  },
  props: {
    meal: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: ""
    },
    date: {
      type: Date,
      default: null
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'toggleSize'],
  data: () => ({
    localMeal: {},

    displayComment: false,
    saving: false,
    showSaving: false,
    searchingIngredients: false,

    showRecipeSearch: false,
    searchby: 'recipe',
    searchBySwitch: false,
    searchDishType: null,
    allowCloseSearchBy: false,
    searchLoading: false,
    selectedRecipe: null,

    searchRecipe: null,
    searchRecipeResults: [],

    selectedRecipeIngredient: null,
    searchIngredientsResults: [],
    searchRecipeIngredient: null,
    searchRecipeByIngredientsResults: [],

    showIdeas: false,
    ideasTab: 'ideas',
    ideasLoading: false,
    ideas: [],
    reuseMealLoader: 0,

    showSeason: false,
    seasonables: [],
    seasonLoading: false,
    leftoverImg,
    restaurantImg,
    otherImg
  }),
  computed: {
    needResize() {
      // More than one
      return !(this.showIdeas + this.showRecipeSearch + this.showSeason > 1)
    },
    extensionOpened () {
      return this.showIdeas || this.showRecipeSearch || this.showSeason
    },
    timeLabel() {
      const type = this.localMeal.type || this.type
      if(!type) return ""; // for saving since there is a re-render with empty meal

      const currType = Meal.allTypes().filter(t => t.name === type)[0]
      return currType.label + ' du ' + _.capitalize(moment(this.localMeal.date).format('dddd D'))
    },
    mealDay() {
      return moment(this.localMeal.date).format('dddd')
    },
    dishTypes() {
      return Recipe.dishTypes()
    },
    batchIngs() {
      const ings = useRepo(Ingredient)
        .withAllRecursive()
        .whereHas('composition', (compoQuery) => {
          compoQuery.whereHas('meal', (mealQuery) => {
            mealQuery.where((meal) => moment(meal.date).isSame(this.localMeal.date, 'week'))
          })
        })
        .where('type', (t) => t !== 'spice' && t !== 'drink')
        .get()

      ings.map(i => {
        i.composition = i.composition
          .filter(c => c.meal && moment(c.meal.date).isSame(this.localMeal.date, 'week'))
          .sort((a, b) => {
            return moment(a.meal.date).isAfter(b.meal.date) ? 1 : -1
          })
        return i
      })

      // Sorting by type of gorcery
      const sections = Ingredient.allTypes()
      const found = {}
      sections.map(t => {
        t.ingredients = ings.filter(i => {
          if (i.type === t.value) {
            found[i.id] = true
            return true
          }
        })
      })
      // Getting all groceries with ingredient with no type
      const otherIngs = ings.filter(i => {
        return !found[i.id]
      })
      sections.push({
        text: "Autre",
        pluralText: "Autres",
        value: "_",
        ingredients: otherIngs
      })

      return sections
    },
    lastMeals() {
      return useRepo(MealRepo)
        .withAllRecursive()
        .where('ignored', false)
        .where('date', (value) => moment.utc(value).isBetween(moment.utc(this.localMeal.date).subtract(7, 'days'), this.localMeal.date))
        .orderBy(m => moment.utc(m.date).unix(), 'desc')
        .get()
    }
  },
  watch: {
    'localMeal.ignored_type': function (newVal) {
      this.localMeal.ignored = newVal !== '';
      if (newVal === 'other' && !this.displayComment) {
        this.displayComment = true;
        setTimeout(() => this.$refs.comment && this.$refs.comment.focus(), 100);
      }
    },
    searchRecipeIngredient: _.debounce(async function (val) {
      if(!this.selectedRecipeIngredient && val) {
        this.searchLoading = true
        try {
          const results = await useRepo(IngredientRepo).$search(val)
          this.searchIngredientsResults = results.data.matches
        }
        catch(e) {
          const toast = useToast()
          toast('Impossible de chercher parmis les ingrédients pour le moment.', {
            type: 'error'
          })
        }
        this.searchLoading = false
      }
    }, 500)
  },
  created() {
    this.localMeal = this.meal
    if (!this.localMeal.leftover_source_ids) {
      this.localMeal.leftover_source_ids = []
    }
    if (this.localMeal.ignored === undefined) {
        this.localMeal.ignored = false;
    }
    if (this.localMeal.ignored_type === undefined) {
        this.localMeal.ignored_type = '';
    }
  },
    mounted() {
    if (this.focus) {
      const that = this;
      if (this.localMeal.id && this.localMeal.ignored) {
        setTimeout(() => that.$refs.comment && that.$refs.comment.focus(), 100);
      } else {
        setTimeout(() => that.$refs.name && that.$refs.name.focus(), 100);
      }
    }
    if (this.localMeal.comment) {
      this.displayComment = true;
    }
  },
  methods: {
    addIgnoredLeftover (mealId) {
      this.localMeal.leftover_source_ids.push(mealId)
    },
    removeIgnoredLeftover (mealId) {
      this.localMeal.leftover_source_ids.splice(this.localMeal.leftover_source_ids.indexOf(mealId), 1)
    },
    isIgnoredLeftover (mealId) {
      return this.localMeal.leftover_source_ids && this.localMeal.leftover_source_ids.indexOf(mealId) > -1
    },
    formatMeal(id, defaultValue) {
      const meal = useRepo(Meal).find(id)
      return meal ? meal.summary : (defaultValue ? defaultValue : '')
    },
    formatIngType(type) {
      return Ingredient.allTypes().filter(t => t.value === type)[0].text
    },
    hideOtherExtensions(source) {
      switch (source) {
        case 'ideas':
          this.showRecipeSearch = false
          this.showSeason = false
          break;
        case 'recipeSearch':
          this.showIdeas = false
          this.showSeason = false
          break;
        case 'season':
          this.showIdeas = false
          this.showRecipeSearch = false
          break;
      }
    },
    toggleComment() {
      this.displayComment = !this.displayComment
      if(this.displayComment) {
        setTimeout(() => this.$refs.comment.focus(), 100)
      }
    },
        saveMeal: async function () {
      this.saving = true
      const mealToSave = _.cloneDeep(this.localMeal)

      if (mealToSave.ignored) {
        // If it's an ignored meal, clean up standard meal fields
        mealToSave.name = ''
        mealToSave.recipes = []
        mealToSave.nb_people = null
        if (mealToSave.ignored_type !== 'leftover') {
          mealToSave.leftover_source_ids = []
        }
      } else {
        // If it's a standard meal, clean up ignored meal fields
        mealToSave.ignored_type = ''
        mealToSave.leftover_source_ids = []
      }

      let response
      if (mealToSave.id) {
        response = await useRepo(MealRepo).$update(mealToSave.id, mealToSave)
      } else {
        response = await useRepo(MealRepo).$create(mealToSave)
      }
      const newId = response.id

      if (!mealToSave.ignored) {
        await useRepo(MealRepo).$loadRecipes(newId)
        await this.updateIngredients(newId)
      }

      this.saving = false
      this.$emit('close')
    },
    close() {
      this.$emit('close')
    },
    updateIngredients: async function(mealId) {
      this.searchingIngredients = true
      const meal = useRepo(Meal).find(mealId)
      if(meal) {
        await useRepo(MealRepo).$updateIngredients(meal.id)
        this.searchingIngredients = false
      }
      else {
        //console.error('No meal found for mealId '+mealId)
      }
    },
    toggleRecipeSearch (presets) {
      this.showRecipeSearch = !this.showRecipeSearch
      if (this.needResize) this.$emit('toggleSize')
      if (this.showRecipeSearch) {
        this.hideOtherExtensions('recipeSearch')
        setTimeout(()=>{
          if(presets && presets.filter === 'ingredient' && presets.filterValue) {
            this.searchby = 'ingredient'
            this.selectedRecipeIngredient = useRepo(Ingredient).find(presets.filterValue)
            this.triggerSearchRecipeByIngredient()
          }
          else {
            this.$refs.searchRecipeInput.focus()
          }
        }, 100)
      }
      else {
        // reset
        this.searchby = 'recipe'
        this.searchRecipe = null
        this.searchRecipeResults = []

        this.selectedRecipeIngredient = null
        this.searchIngredientsResults = []
        this.searchRecipeIngredient = null
        this.searchRecipeByIngredientsResults = []
      }
    },
    triggerSearchRecipe: _.debounce(async function (value) {
      if (value) {
        this.searchLoading = true
        useRepo(RecipeRepo).$search(value,
                       'recipe',
                       this.searchDishType ? {'dish_type': this.searchDishType} : null)
          .then(res => {
            // Use entities cleanup by store
            this.searchRecipeResults = res.data || []
          })
          .catch(err => {
            const toast = useToast()
            toast('Impossible de chercher parmis les recettes pour le moment.', {
              type: 'error'
            })
          })
          .finally(() => {
            this.searchLoading = false
          })
      }
    }, 500),
    triggerSearchRecipeByIngredient: _.debounce(async function () {
      if(this.selectedRecipeIngredient) {
        this.searchLoading = true
        this.searchRecipeIngredient = ''
        try {
          const res = await useRepo(RecipeRepo).$search(this.selectedRecipeIngredient.id, 'ingredient')

          // Use entities cleanup by store
          this.searchRecipeByIngredientsResults = res.data || []
        }
        catch(err) {
          const toast = useToast()
          toast('Impossible de chercher parmis les recettes pour le moment.', {
            type: 'error'
          })
        }

        this.searchLoading = false

      }
    }, 500),
    addRecipe (recipe) {
      if(recipe) {
        const existing = this.localMeal.recipes.filter(r => r.id === recipe.id).length > 0
        if(!existing) {
          if(this.localMeal.recipes.length === 0) {
            this.localMeal.nb_people = parseInt(recipe.nb_people)
          }
          this.localMeal.recipes.push({
            recipe_id: recipe.id,
            recipe: recipe
          })

          if(this.localMeal.name === '') {
            this.localMeal.name = recipe.name
          }
        }
      }
    },
    removeRecipe (recipeId) {
      if(recipeId) {
        const existing = this.localMeal.recipes.findIndex(r => r.recipe_id === recipeId)
        if(existing > -1) {
          this.localMeal.recipes.splice(existing, 1)
        }
      }
    },
    async toggleIdeas () {
      this.showIdeas = !this.showIdeas
      if (this.needResize) this.$emit('toggleSize')
      if(this.showIdeas) {
        this.hideOtherExtensions('ideas')
        if(this.ideas.length === 0) {
          this.ideasLoading = true
          useRepo(MealRepo).$getByDayOfWeek(parseInt(moment(this.localMeal.date).format('d')) + 1, '')
            .then(response => {
              this.ideas = response.data
              this.ideasLoading = false
            })
        }
      }
    },
    async toggleSeason () {
      this.showSeason = !this.showSeason
      if (this.needResize) this.$emit('toggleSize')
      if (this.showSeason) {
        this.hideOtherExtensions('season')
        if(this.seasonables.length === 0) {
          this.seasonLoading = true
          this.seasonables = await useRepo(IngredientRepo).$getSeasonables()
          this.seasonLoading = false
        }
      }
    },
    getMealBakingTypes(meal) {
      if(meal && meal.recipes && meal.recipes.length) {
        const bt = meal.bakingTypes
        if(bt) {
          return ' - ' + bt
        }

        return ''
      }

      return ''
    },
    async reuseMeal(id, name) {
      this.reuseMealLoader = id
      this.localMeal.name = name
      const recipes = await useRepo(RecipeRepo).$getByMeal(id)
      recipes.forEach(r => {
        this.addRecipe(r)
      });
      this.reuseMealLoader = 0
    },
    addIngredient(txt) {
      if(this.localMeal.name === '') {
        this.localMeal.name = txt
      }
      else {
        this.localMeal.name += ', '+txt
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-with-shadow {
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.8);
}

.ignoredCardLabel {
  width: 100%;
  word-break: break-word;
}

.ignoredImageCard {
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  border: 2px solid transparent !important;

  &.selected {
    border-color: rgb(var(--v-theme-primary)) !important;
    box-shadow: 0 0 12px rgba(var(--v-theme-primary), 0.45) !important;
  }
}

.selected-overlay-badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.mealEditionCard {
  .nbPeople {
    input {
      text-align: center;
    }
  }
}
.searchResults {
  max-height: 300px;
  overflow: auto;
}
.name :deep(textarea) {
  max-height: 150px;
  overflow-y: auto;
  margin: 5px 0;
}

.extensionContainer {
  max-height: 300px;
  overflow: auto;
}

.inlineTooltip {
  display: inline-block;
}

.placeholderIngImage {
  width: 24px;
}
</style>